module.exports = __webpack_public_path__ + "static/media/05_galeria_plantillas_combo_duo_cuad_6.770c8d60.png";